import styled from 'styled-components'
import { useParams } from 'react-router-dom'
import { cloneElement } from 'react'
import PropTypes from 'prop-types'

import { Flex } from '@h2/components/layout/flex'
import { PB97T, WHITE, BLACK } from '@h2/components/colors'
import { features } from '@h2/components/media'

import { Loader } from '../../loading/loader'

const getSelectedStyles = ({ selected }) => {
  if (selected) {
    return `
        p {
          color: ${BLACK};
          font-weight: 600;
        }
      `
  }
}
const ListContainer = styled.li`
  list-style: none;
  padding: 10px 5px;
  min-height: 30px;
  border-radius: 5px;
  background: linear-gradient(to right, ${PB97T} 50%, ${WHITE} 50%);
  background-size: 200% 100%;
  background-position: ${({ selected }) => (selected ? 'left bottom' : 'right bottom')};
  border-top: solid 2px ${PB97T};
  border-bottom: solid 2px ${PB97T};
  overflow: hidden;
  text-overflow: ellipsis;
  ${getSelectedStyles};
  a {
    display: block;
    text-align: left;
    &:hover,
    &:active,
    &:visited {
      text-decoration: none;
    }
  }
  &:hover {
    background-position: left bottom;
    transition: all 0.3s ease;
    border-top: solid 2px ${WHITE};
    border-bottom: solid 2px ${WHITE};
    a,
    p {
      text-decoration: none;
      color: ${BLACK};
      font-weight: 600;
    }
  }

  :first-of-type {
    border-top: none;
  }
  :last-of-type {
    border-bottom: none;
  }
`
const List = styled.ul`
  max-width: 25%;
  min-width: 250px;
  margin: 0;
  padding: 10px 0;
  border-right: solid 10px ${PB97T};
  @media (${features.maxWidth.laptop}) {
    display: none;
  }
`
const ContentHolder = styled.div`
  padding: 15px;
  width: 100%;
`
const ListWithDetail = ({ results, resultRenderer, paramKey, isFetching, children }) => {
  const key = useParams()[paramKey]
  const selectedRecord = results && results.find(rec => `${rec.id}` === key)

  if (isFetching) {
    return <Loader />
  }

  return (
    <Flex>
      <List>
        {results?.map((rslt, idx) => (
          <ListContainer selected={selectedRecord === rslt} key={idx}>
            {resultRenderer(rslt)}
          </ListContainer>
        ))}
      </List>
      <ContentHolder>{cloneElement(children, { selectedRecord })}</ContentHolder>
    </Flex>
  )
}

ListWithDetail.propTypes = {
  results: PropTypes.arrayOf(PropTypes.object),
  resultRenderer: PropTypes.func,
  paramKey: PropTypes.string,
  isFetching: PropTypes.bool
}

export { ListWithDetail }
